/**
 * @license
 * Copyright 2014 Travis Webb
 * SPDX-License-Identifier: MIT
 */for (var t = 0; t < 256; t++) (t >> 4 & 15).toString(16) + (t & 15).toString(16);